import type { IRole } from '~/types/role'

import config from '~/config'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'
import { request } from '~/utils/request'

export const getRoles = (): Promise<IPaginatedResponse<IRole>> => {
  return request({
    params: {
      size: DEFAULT_ITEMS_PER_PAGE_VALUE,
    },
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role/search`,
  })
}

export const getRole = (roleId: string): Promise<IRole> => {
  return request({
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role/${roleId}`,
  })
}

export const createRoles = (
  roles: { authorization_keys: string[]; description: string; name: string }[]
): Promise<IRole[]> => {
  return request({
    data: roles,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role`,
  })
}

export const updateRole = (role: { description?: string; id: string; name: string }): Promise<IRole> => {
  return request({
    data: {
      description: role.description,
      name: role.name,
    },
    method: 'PUT',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role/${role.id}`,
  })
}

export const addAuthsInRole = (role: { authKeys: string[]; roleId: string }): Promise<IRole> => {
  return request({
    data: role.authKeys,
    method: 'PATCH',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role/${role.roleId}/authorization`,
  })
}

export const deleteAuthsInRole = (role: { authKeys: string[]; roleId: string }): Promise<IRole> => {
  return request({
    data: role.authKeys,
    method: 'DELETE',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/role/${role.roleId}/authorization`,
  })
}
